module.exports = __webpack_public_path__ + "media/images/icons/outlined/vertical-right-fcf4c9d44d51de72cba189ad31d59071.svg";